import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../modules/auth/services/session.service';
import { environment } from '../../environments/environment';

/**
 * Auth Interceptor
 *
 * Dodaje Authorization header do żądań kierowanych do NASZEGO API.
 * Używa SessionService (nie AuthService!) aby uniknąć circular dependency.
 *
 * Logika refresh tokena jest w TokenRefreshInterceptor.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private sessionService: SessionService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Token TYLKO do naszego API. Nigdy nie dołączaj go do żądań cross-origin
    // (np. geokoder nominatim.openstreetmap.org, pliki i18n). Powód podwójny:
    //  1) bezpieczeństwo — to wyciek tokena uwierzytelniającego do obcego serwisu,
    //  2) CORS — Authorization czyni żądanie "non-simple", więc przeglądarka robi
    //     preflight OPTIONS, którego zewnętrzny serwer nie obsługuje → "Błąd CORS"
    //     (objawiał się jako brak podpowiedzi adresu, zwłaszcza dla świeżych,
    //     niezbuforowanych zapytań — stąd złudne "tylko polskie znaki nie działają").
    if (!request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }

    // NIE dodawaj Authorization header dla /auth/refresh (używa HttpOnly Cookie!)
    if (request.url.includes('/auth/refresh')) {
      return next.handle(request);
    }

    // Pobierz Authorization header z SessionService
    const authHeader = this.sessionService.getAuthorizationHeader();

    if (authHeader) {
      request = request.clone({
        setHeaders: {
          Authorization: authHeader
        }
      });
    }

    return next.handle(request);
  }
}
